import ja from './translations/ja.json'

// English is the default message in each of our source files, so no need for a separate en.json file
const en = {}

// If we add more than just japanese, just import the files and export it below: export default { en, es, js }
export default { en, ja }
